import { Button } from '@chakra-ui/react'
import { FormProvider, useForm } from 'react-hook-form'

import {
  FormSection,
  FormSectionBody,
  FormSectionDescription,
  FormSectionHeader,
  FormSectionTitle,
} from '../../components/FormSection'
import { MainContent } from '../../components/MainContent'
import { FormButtons } from '../FormButtons'
import { Save } from '../../icons'
import { ExtraInsuranceProperty } from '../ExtraInsuranceProperty'
import { DiscountsProperties } from '../discounts/DiscountsProperties'

interface Step2FormProps {
  onSubmit: Function
}

export interface Step2FormValues {
  assistance: boolean
  assistanceExtra: boolean
  brokenPipe: boolean
  theft: boolean
  glassDamage: boolean
  flood: boolean
  elecricityShort: boolean
  vandalism: boolean
  waterPipesDamage: boolean
  atmosphericLeakage: boolean
  naturalDamage: boolean
  propertyOwnershipLiability: boolean
  propertyOwnershipLiabilityValue: number
  lifeLiability: boolean
  lifeLiabilityValue: number
  valorization: boolean
  newPriceInsurance: boolean
  insuredPropertyValue: number
  insuredHouseholdValue: number
}

export const Step2Form = ({ onSubmit }: Step2FormProps) => {
  const methods = useForm<Step2FormValues>({
    defaultValues: {
      propertyOwnershipLiabilityValue: 3000000,
      lifeLiabilityValue: 5000000,
      insuredPropertyValue: 20000000,
      insuredHouseholdValue: 200000,
    },
  })
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods

  const onSubmitForm = (values: Step2FormValues) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        onSubmit(values)
        resolve(true)
      }, 500)
    })
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmitForm)}>
        <MainContent>
          <FormSection>
            <FormSectionHeader>
              <FormSectionTitle>Připojištění</FormSectionTitle>

              <FormSectionDescription>
                Vyberte limity zvoleného připojišťění.
              </FormSectionDescription>
            </FormSectionHeader>

            <FormSectionBody>
              <ExtraInsuranceProperty />
            </FormSectionBody>
          </FormSection>

          <FormSection>
            <FormSectionHeader>
              <FormSectionTitle>Slevy pojištění</FormSectionTitle>

              <FormSectionDescription>
                Nastavte slevy pojistníka a jednotlivých pojišťoven.
              </FormSectionDescription>
            </FormSectionHeader>

            <FormSectionBody>
              <DiscountsProperties />
            </FormSectionBody>
          </FormSection>

          <FormButtons
            rightButtons={
              <>
                <Button variant="outline" disabled={isSubmitting} type="button">
                  Uložit
                </Button>
                <Button
                  colorScheme="primary"
                  isLoading={isSubmitting}
                  isDisabled={isSubmitting}
                  loadingText="Počítám nabídky..."
                  type="submit"
                >
                  <Save />
                  Uložit a spočítat nabídky
                </Button>
              </>
            }
          />
        </MainContent>
      </form>
    </FormProvider>
  )
}
